import {FormControl, FormField, Label} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useId} from 'react';

import {CurrencyCodeType, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {VehicleFinancingTemplateFormValues} from '../schemas/vehicleFinancingTemplateFormSchema';

type OneTimeCostIncludedName =
  'vehicleTransferIncluded' | 'vehicleRegistrationIncluded' | 'vehicleDeliveryIncluded';

type OneTimeCostAmountName =
  'vehicleTransferAmount' | 'vehicleRegistrationAmount' | 'vehicleDeliveryAmount';

interface OneTimeCostFieldProps extends RequiredTestIdProps {
  control: FormControl<VehicleFinancingTemplateFormValues>;
  label: string;
  checkboxAriaLabel: string;
  includedName: OneTimeCostIncludedName;
  amountName: OneTimeCostAmountName;
  currency: CurrencyCodeType;
}

export function OneTimeCostField(props: OneTimeCostFieldProps) {
  const amountFieldId = useId();

  return (
    <VStack>
      <Label id={amountFieldId} data-testid={suffixTestId('label', props)}>
        {props.label}
      </Label>
      <HStack spacing={2} align="center">
        <FormField
          control={props.control}
          name={props.includedName}
          type="checkbox"
          aria-label={props.checkboxAriaLabel}
          data-testid={suffixTestId('included', props)}
        />
        <Box flex={1}>
          <FormField
            control={props.control}
            name={props.amountName}
            type="currency"
            id={amountFieldId}
            currency={props.currency}
            decimalPlaces={2}
            data-testid={suffixTestId('amount', props)}
          />
        </Box>
      </HStack>
    </VStack>
  );
}
